import { TooltipProvider } from "@reactive-resume/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router";

import { helmetContext } from "../constants/helmet";
import { queryClient } from "../libs/query-client";
import { AuthRefreshProvider } from "./auth-refresh";
import { AuthProvider } from "./auth-provider";
import { DialogProvider } from "./dialog";
import { LocaleProvider } from "./locale";
import { PostHogWrapper } from "./posthog";
import { ThemeProvider } from "./theme";
import { Toaster } from "./toaster";
import { UsageLimitDialog } from "@/client/components/usage-limit-dialog";
import { AuthRequiredDialog } from "@/client/components/auth-required-dialog";
import { CookieModal } from "@/client/components/cookie-modal";
import { CookieBanner } from "@/client/components/cookie-banner";

export const Providers = () => (
  <LocaleProvider>
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <PostHogWrapper>
          <AuthProvider>
            <AuthRefreshProvider>
              <ThemeProvider>
                <TooltipProvider>
                  <DialogProvider>
                    <UsageLimitDialog />
                    <AuthRequiredDialog />
                    <Outlet />
                    <Toaster />
                    <CookieModal />
                    <CookieBanner />
                  </DialogProvider>
                </TooltipProvider>
              </ThemeProvider>
            </AuthRefreshProvider>
          </AuthProvider>
        </PostHogWrapper>
      </QueryClientProvider>
    </HelmetProvider>
  </LocaleProvider>
);
